import { CLASSES, DOM } from '../_consts';
import Utility from '../helpers/Utility';

const { isActive, isOpen } = CLASSES;


export default function filter() {
  const { $body } = DOM;
  const filterItem = '.js-filter-item';

  $body.on('click', '.js-filter-more', () => {
    $('.js-filter-item-hidden').toggle();
    $('.js-filter-more').toggleClass(isActive);
  });

  $body.on('click', '.js-filter-trigger', e => {
    const $target = $(e.currentTarget);
    const parentItem = $target.closest(filterItem);
    parentItem.toggleClass(isActive)
  });

  $body.on('click', '.js-toggle-controls', (e) => {
    const $target = $(e.currentTarget);
    const parentItem = $target.closest(filterItem);
    $target.toggleClass(isActive);
    parentItem.toggleClass(isOpen);
  });

  $body.on('click', '.js-checkbox-control', () => {
    setTimeout(() => {
      window.instances.forEach((ins) => {
        ins.update();
      });
    }, 250);
  });

  $body.on('click', '.js-show-mob-filter', () => {
    $('.js-filter').addClass(isOpen);
    Utility.addBodyHidden();
    $body.addClass('is-filter-opened');

    setTimeout(() => {
      window.instances.forEach((ins) => {
        ins.update();
      });
    }, 250);
  });

  $body.on('click', '.js-filter-close', () => {
    $('.js-filter').removeClass(isOpen);
    $body.removeClass('is-filter-opened');
    Utility.removeBodyHidden();
  })

}
